if (!customElements.get("scroll-to-top scroll-to-top-new")) {
  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this.triggerHeight  = window.innerHeight;
      this.handleScrollEvent = this.toggleVisibility.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.scrollToTopHandler);
      window.addEventListener("scroll", this.handleScrollEvent);
      this.toggleVisibility();
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.scrollToTopHandler);
      window.removeEventListener("scroll", this.handleScrollEvent);
    }

    toggleVisibility() {
      const isButtonVisible = window.scrollY > this.triggerHeight;
      this.classList.toggle("scroll-to-top--visible", isButtonVisible);
    }

    scrollToTopHandler() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  customElements.define("scroll-to-top", ScrollToTop);
}
// ✅ Add scroll-to-top behavior for a separate class element
document.addEventListener("DOMContentLoaded", () => {
  const imageTrigger = document.querySelector(".scroll-to-top-new");

  if (imageTrigger) {
    imageTrigger.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const detailsMenu = document.querySelector('details.menu-drawer-container');
  const scrollTopEl = document.querySelector('scroll-to-top');

  if (detailsMenu && scrollTopEl) {
    detailsMenu.addEventListener('toggle', () => {
      if (detailsMenu.open) {
        scrollTopEl.classList.remove('scroll-to-top--visible');
      } else {
        // When closed, force recheck scroll position to show/hide properly
        scrollTopEl.toggleVisibility?.(); // Optional chaining in case it is not yet loaded
      }
    });
  }

  const imageTrigger = document.querySelector(".scroll-to-top-new");
  if (imageTrigger) {
    imageTrigger.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
});

